import styled, { keyframes } from 'styled-components';
import { typeScale } from 'core/utils';
import { getColor } from 'core/utils/Styles';
import { resetBtn } from 'styled-manila';
import Button from 'core/ui/Button';
import { desktop } from 'core/components/Form/formStyles';
import {
	Input as Inpt,
	Textarea as Txtarea
} from 'core/components/Form';


export const Wrapper = styled.div`
	background-color: ${getColor('white')};
	border-radius: 4px;
	position: relative;
	max-width: 650px;
	height: 100%;
	width: 99vw;
	@media (min-width: 620px) {
		width: 92vw;
	}
`;

export const Flex = styled.div`
	display: flex;
	flex-direction: column;
	height: 100%;
`;

export const Heading = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 64px;
`;

export const Header = styled.h3`
	color: ${getColor("gray")};
	font-size: 20px;
	line-height: 1.05;
	letter-spacing: 0.2px;
	margin: 0;
	padding: 0 ${typeScale(2)};
`;

export const Body = styled.div`
	color: ${getColor("gray")};
	padding: ${typeScale(2)} ${typeScale(2)} ${typeScale(3)};
	overflow-y: auto;
	flex: 2;

	${desktop`
		padding: ${typeScale(2)} ${typeScale(3)} ${typeScale(3)};
	`}
`;

export const DismissBtn = styled.button`
	${resetBtn};
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${getColor('dustyGray')};
	padding: 17px;
`;

export const StyledButton = styled(Button)`
	line-height: 1;
	white-space: nowrap;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Link = styled.a`
	font-weight: 600;
	padding: 0 ${typeScale(1)};
`;

export const InputWrapper = styled.div`
	padding: ${typeScale(2)} 0;
`;

export const Input = styled(Inpt)`
	box-shadow: none;
`;

export const Textarea = styled(Txtarea)`
	box-shadow: none;
`;

export const ButtonRow = styled.div`
	display: flex;
	flex-direction: column-reverse;
	align-items: center;
	justify-content: space-between;
	margin-top: 0;

	${/* sc-sel */Link} { margin-top: 16px; }
	button { width: 100%; }

	${desktop`
		flex-direction: row;

		${/* sc-sel */Link} { margin-top: 0; }
		button { width: auto; }
	`}
`;

export const ReviewGuidelines = styled(ButtonRow)`
	margin-top: 10px;
	margin-bottom: 10px;

	a {
		padding: 0;
	}
`;

export const RatingLabel = styled.div`
	font-weight: 600;
	margin-bottom: 8px;
`;

export const RatingDivider = styled.div`
	margin-top: 12px;
	margin-bottom: 18px;
	border-bottom: 1px solid ${getColor('mercury')};
`;

export const SuccessText = styled.p`
	color: ${getColor('dustyGray')};
	margin-bottom: 24px;
`;

export const SuccessButton = styled(Button)`
	width: 100%;

	${desktop`
		width: auto;
	`}
`;

export const LoginWrapper = styled.div`
	margin: 0 auto;
	max-width: 300px;
`;

const slideInDown = keyframes`
	from {
		transform: translate3d(0, -100%, 0);
		visibility: visible;
		height: 0;
	}
	to {
		transform: translate3d(0, 0, 0);
		height: 48px;
	}
`;

export const ContactSellerText = styled.div`
	animation: 250ms ${slideInDown} ease-out;
	margin: 4px 0;
`;

export const FormStyled = styled.form`
	padding-bottom: 16px;
`;
